import messagesNl from "../../translations/nl.json";

export const localeNl = {
    lang: 'nl',
    messages: messagesNl
};